import React, { useId } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import classNames from "./classNames";

const QuantityPicker = ({
  value = 1,
  onChange,
  min = 1,
  max = 99,
  disabled = false,
  className,
  label = "Quantity",
  id,
}) => {
  const generatedId = useId();
  const inputId = id || `quantity-${generatedId.replace(/:/g, "")}`;
  const numericValue = Math.min(max, Math.max(min, Number(value) || min));

  const updateValue = (nextValue) => {
    const safeValue = Math.min(max, Math.max(min, Number(nextValue) || min));
    onChange?.(safeValue);
  };

  return (
    <div className={classNames("quantity-picker", className)}>
      <label className="visually-hidden" htmlFor={inputId}>
        {label}
      </label>
      <button
        className="quantity-picker__button"
        type="button"
        onClick={() => updateValue(numericValue - 1)}
        disabled={disabled || numericValue <= min}
        aria-label={`Decrease ${label.toLowerCase()}`}
      >
        <FiMinus aria-hidden="true" />
      </button>
      <input
        className="quantity-picker__input"
        id={inputId}
        type="number"
        inputMode="numeric"
        value={numericValue}
        min={min}
        max={max}
        disabled={disabled}
        onChange={(event) => updateValue(event.target.value)}
      />
      <button
        className="quantity-picker__button"
        type="button"
        onClick={() => updateValue(numericValue + 1)}
        disabled={disabled || numericValue >= max}
        aria-label={`Increase ${label.toLowerCase()}`}
      >
        <FiPlus aria-hidden="true" />
      </button>
    </div>
  );
};

export default QuantityPicker;
